<template>
	<div
		class="px-2 caption d-inline-flex white--text font-weight-bold rounded-pill mr-2 align-center"
		:style="{ background: color }"
	>
		<span>
			{{ tagName }}
		</span>
		<v-btn
			@click="$emit('removeTag', id)"
			icon
			v-if="removalPossibility"
			x-small
		>
			<v-icon color="white" x-small> mdi-close </v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	props: {
		id: Number,
		tagName: String,
		color: { type: String, default: "red" },
		removalPossibility: { type: Boolean, default: true },
	},
};
</script>
